import { useToast } from 'modules/toast/hooks/useToast';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from 'shared/components/Button/Button';
import { useSitemap } from 'shared/hooks/useSitemap';

interface ExtractionErrorOnboardingRedirectButtonProps {
  onRedirect?: () => void;
  label?: string;
}

export const ExtractionErrorOnboardingRedirectButton: FC<
  ExtractionErrorOnboardingRedirectButtonProps
> = ({ onRedirect, label }) => {
  const { t } = useTranslation('pageTitles');
  const navigate = useNavigate();
  const sitemap = useSitemap();
  const { dismissToast, setExtractionAcknowledged } = useToast();

  const handleClick = useCallback(async () => {
    navigate(sitemap.profile());
    setExtractionAcknowledged();
    dismissToast();
  }, [navigate, sitemap, onRedirect]);

  return (
    <Button
      variant="text"
      onClick={handleClick}
      className="!inline-block text-xs"
      name="extractionErrorConfirmButton"
    >
      {label ?? t('profile')}
    </Button>
  );
};
